import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { useToast, POSITION } from "vue-toastification";
  import ChartForReports from "@/components/reports/ChartForReports.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { ReportsTimePeriod } from "@/enums/ReportsTimePeriod";
  import { BuyerTypes } from "@/enums/BuyerTypes";
  import { ChartsTypes } from "@/enums/ChartsTypes";
  import { AnalyticsBuyerTypePostcodeAndState } from "@/types/AnalyticsBuyerTypeInterface";
  import {
    backgroundColorForBuyerLocation,
    backgroundColorForBuyerLocationBar,
    optionsPieChartBuyerLocation,
    optionsForHorizontalBarchart,
  } from "@/constants/optionsChart";
  import dayjs from "dayjs";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuyerLocation',
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
    searchKey: {
      type: Number,
      required: true,
    },
    estateSelected: {
      type: String,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const store = useStore();
  const toast = useToast();
  const loading = ref(false);
  const buyerTypeFromPostcodeAndState = ref<
    AnalyticsBuyerTypePostcodeAndState[]
  >([]);

  const landownerId = computed(() => store.state.user.data._id);

  const startDateSelected = computed(() => {
    return props.startDate;
  });

  const endDateSelected = computed(() => {
    return props.endDate;
  });

  const estateSelected = computed(() => {
    return props.estateSelected;
  });

  watch(
    () => props.searchKey,
    () => {
      getBuyerTypesPostcodeAndState();
    }
  );

  const getBuyerTypesPostcodeAndState = async () => {
    if (landownerId.value) {
      loading.value = true;
      const formattedStartDate = dayjs(props.startDate).format("MM/DD/YYYY");
      const formattedEndDate = dayjs(props.endDate).format("MM/DD/YYYY");

      store
        .dispatch("analytics/getBuyerTypesPostcodeAndState", {
          landownerId: landownerId.value,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          estateSelected: estateSelected.value,
        })
        .then((res) => {
          sortPostcodesAnalytics(res.data);
          buyerTypeFromPostcodeAndState.value = res.data;
        })
        .catch((err) => {
          toast.error("Error getting buyer types from postcode and state", {
            position: POSITION.TOP_LEFT,
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }
  };

  const sortPostcodesAnalytics = (
    data: AnalyticsBuyerTypePostcodeAndState[]
  ) => {
    data.forEach((analytic) => sortPostcodesAnalytic(analytic));
  };

  const sortPostcodesAnalytic = (
    analytic: AnalyticsBuyerTypePostcodeAndState
  ) => {
    const combinedPostcodes: [string, number][] = [];

    for (let i = 0; i < analytic.postcode.length; i++) {
      combinedPostcodes.push([analytic.postcode[i], analytic.totalPostcode[i]]);
    }

    combinedPostcodes.sort((a, b) => b[1] - a[1]);

    const length = analytic.postcode.length;

    analytic.postcode = [];
    analytic.totalPostcode = [];

    for (let i = 0; i < 5; i++) {
      if (!combinedPostcodes[i]) {
        analytic.postcode.push("");
        analytic.totalPostcode.push(0);
      } else {
        analytic.postcode.push(combinedPostcodes[i][0]);
        analytic.totalPostcode.push(combinedPostcodes[i][1]);
      }
    }
  };

  const shouldRenderCharts = computed(() => {
    return buyerTypeFromPostcodeAndState.value.some((estateData) => {
      return (
        estateData.percentageState.some((value) => value !== 0) ||
        estateData.totalPostcode.some((value) => value !== 0)
      );
    });
  });

  const areAllCountsZero = (counts: number[] = []): boolean => {
    return counts.every((count) => count === 0);
  };

  onMounted(() => {
    getBuyerTypesPostcodeAndState();
  });

const __returned__ = { props, store, toast, loading, buyerTypeFromPostcodeAndState, landownerId, startDateSelected, endDateSelected, estateSelected, getBuyerTypesPostcodeAndState, sortPostcodesAnalytics, sortPostcodesAnalytic, shouldRenderCharts, areAllCountsZero, ref, onMounted, computed, watch, get useStore() { return useStore }, get useToast() { return useToast }, get POSITION() { return POSITION }, ChartForReports, get EstateInterface() { return EstateInterface }, get ReportsTimePeriod() { return ReportsTimePeriod }, get BuyerTypes() { return BuyerTypes }, get ChartsTypes() { return ChartsTypes }, get AnalyticsBuyerTypePostcodeAndState() { return AnalyticsBuyerTypePostcodeAndState }, get backgroundColorForBuyerLocation() { return backgroundColorForBuyerLocation }, get backgroundColorForBuyerLocationBar() { return backgroundColorForBuyerLocationBar }, get optionsPieChartBuyerLocation() { return optionsPieChartBuyerLocation }, get optionsForHorizontalBarchart() { return optionsForHorizontalBarchart }, get dayjs() { return dayjs } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})